import QuotationHistoryPage from './QuotationHistoryPage';

export default QuotationHistoryPage;
